import React, {Component} from 'react';
import StrategyModalCourseAdd from './StrategyModalCourseAdd';
import StrategyModalDiagnosticTest from './StrategyModalDiagnosticTest';
import SortableCoursesContainer from '../../../containers/AdminPanel/Strategy/SortableCoursesContainer';
import AddCourseModal from '../../Common/AddCourseModal';
import SortableRules from './SortableRules';
import SortableSubjects from './SortableSubjects';
import {arrayMove} from "react-sortable-hoc";
import {Link} from 'react-router-dom';

const tabsArr = [
    ['#mcat_tab', 'MCAT'],
    ['#lsat_tab', 'LSAT'],
    ['#gmat_tab', 'GMAT']
];


const strategy = {
    conditions: [
        {
            subjects: [
                {id: 1, type: "subject", condition: "tie", connector: "and"},
                {id: 2, type: "subject", condition: "tie", connector: "and"},
                {id: 3, type: "subject", condition: "score", operator: "<", value: 20, connector: "or"},
                {id: 4, type: "subject", condition: "score", operator: ">", value: 60, connector: "then"}
            ],
            result: 1
        },
        {
            subjects: [1, 2],
            type: "tie",
            result: 1
        }
    ]
}

const condition = {
    subjects: [],
    result: null
}

class StrategyManagement extends Component {
    state = {
        strategy: '',
        newTabModelIsOpen: false,
        // renderNewTab: false,
        newTabName: '',
        activeCourse: null,
        rules: {
            conditions: []
        },
        subjectOrder: [],
        subjectScores: []
    };


    handleNewTabOpenState = () => {
        this.setState({
            newTabModelIsOpen: !this.state.newTabModelIsOpen,
        })
    };

    addNewCourse = (name, slug) => {
        this.props.addNewCourse({name: name, slug: slug, owner: this.props.user.userId, published: false, officialTest: {
            name: "",
            minScore: "",
            maxScore: "",
            sections: [
            {
                name: "",
                minScore: "",
                maxScore: ""
            }
            ]
        }}, this.props.user.id);
                this.setState({
                    newTabName: name,
                });
        tabsArr.push([`#${name.toLowerCase()}_tab`, `${name}`])
    };



    //Renders
    renderTitle = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">
                        Strategy
                    </h1>
                    <small className="text-muted">
                        Strategy Management
                    </small>
                </div>
            </div>
        </div>
    );

    renderNavigationLinks = () => (
        <ul className="nav nav-tabs bg-white">
            {this.renderLink('', '/course-admin', 'Courses', 'All Courses')}
            {this.renderLink('active', '/strategy', 'Onboarding', 'Setup Onboarding')}
            {this.renderLink('', '/people', 'People', 'Access Manager')}
            {this.renderLink('', '/settings-admin', 'Settings', 'Updates')}
        </ul>
    );

    renderLink = (className, link, title ,subTitle) => (
        <li
            className={className}
        >
            <Link to={link}>
                {title}
                <span>
                    {subTitle}
                </span>
            </Link>
        </li>
    );

    updateCourse = () => {
        let course = this.state.activeCourse;
        course.rules = this.state.rules;
        course.subjectOrder = this.state.subjectOrder;
        course.strategy = this.state.strategy;
        this.props.updateCourse(course, this.props.user.userId, this.props.user.id);
    }

    setActiveCourseTest = (test) => {
        let {activeCourse} = this.state;
        activeCourse.testId = test.id;
        if(test.title){
            activeCourse.testName = test.title;
        }else if(test.name){
            activeCourse.testName = test.name;  
        }else{
            activeCourse.testName = "Diagnostic Test";
        }
        this.setState({activeCourse});
        this.updateCourse();
    }

    removeDiagnosticTest = () => {
        let {activeCourse} = this.state;
        activeCourse.testName = '';
        activeCourse.testId = null;
        this.setState({activeCourse});
    }
    
    updateOfficialTest = (key, val) => {
        let {activeCourse} = this.state;
        activeCourse.officialTest[key] = val;
        this.setState({activeCourse});

    }
    
    updateOfficialTestSection = (key, val, i) => {
        let {activeCourse} = this.state;
        activeCourse.officialTest.sections[i][key] = val;
        this.setState({activeCourse});

    }
    
    addOfficialTestSection = () => {
        let {activeCourse} = this.state;
        activeCourse.officialTest.sections.push({name: '', minScore: '', maxScore: ''});
        this.setState({activeCourse});
    }
    
    removeOfficialTestSection = (i) => {
        let {activeCourse} = this.state;
        activeCourse.officialTest.sections.splice(i, 1);
        this.setState({activeCourse});
    }
    
    updateLoadSubjects = () => {
        let {activeCourse} = this.state;
        
        activeCourse.CourseSubject.map(s => {
            if(activeCourse.subjectOrder.indexOf(s.id) === -1){
                activeCourse.subjectOrder.push(s.id);
            }
            return true;
        })
        
        let subo = JSON.parse(JSON.stringify(activeCourse.subjectOrder));
        
        subo.map(s => {
            let subject = activeCourse.CourseSubject.filter(sub => sub.id === s);
            if(subject.length === 0){
                // Remove from subjectOrder
                activeCourse.subjectOrder.splice(activeCourse.subjectOrder.indexOf(s), 1);
            }
        })
        this.setState({activeCourse, subjectOrder: activeCourse.subjectOrder});
    }

    updateAllCourseUserSubjects = () => {
        let {activeCourse} = this.state;
        this.props.updateAllCourseUserSubjects(activeCourse.id, this.props.user.id);
    }

    renderNavigationTabs = () => (
        <ul className="nav nav-tabs">
            <div className="pull-right">
                {this.props.activeCourse.id &&
                    <button className="btn btn-base" onClick={this.updateCourse}>Save Changes</button>
                } &nbsp;
            </div>
            {this.renderTabNew()}
            {/*{this.renderTab('active', '#mcat_tab', 'MCAT')}*/}
            {/*{this.renderTab('', '#lsat_tab', 'LSAT')}*/}
            {/*{this.renderTab('', '#gmat_tab', 'GMAT')}*/}
            {/*{*/}
                {/*this.state.newTabName !== '' &&*/}
                {/*this.renderTab('', '#gfet_tab', `${this.state.newTabName}`)*/}
            {/*}*/}
            {/*/////////////////////*/}
            <div>
                
                <a className="btn btn-orange btn-rounded"
                    onClick={this.handleNewTabOpenState}
                >
                    {this.props.courses.length === 0 &&
                    "Add Course "}
                        <i className="zmdi zmdi-plus-circle"/>

                </a>
            </div>
        </ul>
    );

    renderTabNew = () => {
        return (
            this.props.courses.map((item, index) => {


                return (
                    <li
                        key={index}
                        className={this.props.match.params.courseId === item.id ? 'active' : ''}
                    >
                        <Link
                            to={`/strategy/${item.id}`}
                        >
                            {item.name}
                            
                        </Link>
                    </li>
                )
            })
        )
    };

    renderTabPaneBody = (courses) => (
        <div className="panel customPanel no-bg flat">
            <div className="panel-body bg-dark">
                <div className="sm-bottom30">
                
                    <div className="panel customPanel">
                    <div className="panel-heading" style={{background: "#272727 !important"}}>
                                                                        <h3 className="panel-title">Course Strategy</h3>
                                                                    </div>
                    <div className="panel-body sp-20" style={{background: "#252525 !important"}}>
                    <div className="row">
                        <div className="col-sm-3">
                            <label>
                                <input
                                    type="radio"
                                    name="Strategy_Type"
                                    onChange={(e) => this.handleChangeCheckStrategy(e)}
                                    value="Automated"
                                    checked={this.state.activeCourse.strategy !== 'manual_strategy_active'}
                                />
                                Automated Strategy
                            </label>
                        </div>
                        <div className="col-sm-3">
                            <label>
                                <input
                                    type="radio"
                                    name="Strategy_Type"
                                    onChange={(e) => this.handleChangeCheckStrategy(e)}
                                    value="Manual"
                                    checked={this.state.activeCourse.strategy === 'manual_strategy_active'}
                                />
                                Manual Strategy
                            </label>
                        </div>
                    </div>
                    {this.state.strategy === 'manual_strategy_active' ?
                        this.renderManualStrategy()
                        :
                        this.renderStrategyConditions()}
                </div>
                </div>
                
                </div>
                <div>
                    <div className="panel customPanel">
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-sm-5">
                                    <div className="BtnWithTextBox">
                                        <label>
                                            Diagnostic Test Name:
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={this.state.activeCourse.testName || ''}
                                            onChange={e => null}
                                        />
                                        <a
                                            href="#AddStrategyModal2"
                                            data-toggle="modal"
                                            className="btn btn-info"
                                        >
                                            <i className="zmdi zmdi-plus-circle"/>
                                        </a>
                                    </div>
                                    <a href="#removecourse" onClick={e => {
                                        e.preventDefault();
                                        this.removeDiagnosticTest();
                                    }}>Remove test</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                <div className="panel customPanel">
                                                        	<div className="panel-heading" style={{background: "#272727 !important"}}>
                                                        		<h3 className="panel-title">Official test details</h3>
                                                        	</div>
                                                        	<div className="panel-body" style={{background: "#252525 !important"}}>
                                                                <div className="row">
                                                                    <div className="col-sm-2 text-right">
                                                                        <p className="text-right-md sp-top10">Test Name:</p>
                                                                    </div>
                                                                    <div className="col-sm-10">
                                                                        <div className="form-group">
                                                                            <input type="text" className="form-control" value={this.state.activeCourse.officialTest ? this.state.activeCourse.officialTest.name : '' || ''} onChange={e => this.updateOfficialTest('name', e.target.value)} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-sm-2 text-right">
                                                                        <p className="text-right-md sp-top10">Total score range:</p>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <div className="form-group">
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control" placeholder="Min" value={this.state.activeCourse.officialTest ? this.state.activeCourse.officialTest.minScore : '' || ''} onChange={e => this.updateOfficialTest('minScore', e.target.value)} />
                                                                                <div className="input-group-addon">To</div>
                                                                                <input type="text" className="form-control" placeholder="Max" value={this.state.activeCourse.officialTest ? this.state.activeCourse.officialTest.maxScore : '' || ''} onChange={e => this.updateOfficialTest('maxScore', e.target.value)} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                                {this.state.activeCourse &&
                                                                this.state.activeCourse.officialTest &&
                                                                this.state.activeCourse.officialTest.sections.map((section, sectioni) => {
                                                                    return (
                                                                        <div className="row" key={sectioni}>
                                                                            <div className="col-sm-2 text-right">
                                                                                <p className="text-right-md" data-toggle="tooltip" title="More Details about this heading can be placed here">Section Name &amp; Placeholder Text: <span className="fa fa-question-circle text-info"></span> </p>
                                                                            </div>
                                                                            <div className="col-sm-10">
                                                                                <div className="section-names-and-placholder-texts">
                                                                                    <div className="row">
                                                                                        <div className="col-sm-6">
                                                                                            <div className="form-group">
                                                                                                <input type="text" className="form-control" value={this.state.activeCourse.officialTest.sections[sectioni].name || ''} onChange={e => this.updateOfficialTestSection('name', e.target.value, sectioni)} />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-sm-4">
                                                                                            <div className="form-group">
                                                                                                <div className="input-group">
                                                                                                    <input type="text" className="form-control" placeholder="Min Text" value={this.state.activeCourse.officialTest.sections[sectioni].minScore || ''} onChange={e => this.updateOfficialTestSection('minScore', e.target.value, sectioni)} />
                                                                                                    <div className="input-group-addon">To</div>
                                                                                                    <input type="text" className="form-control" placeholder="Max Text" value={this.state.activeCourse.officialTest.sections[sectioni].maxScore || ''} onChange={e => this.updateOfficialTestSection('maxScore', e.target.value, sectioni)} />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-sm-2">
                                                                                            {sectioni === 0 ?
                                                                                            <a href="#" className="btn btn-default btn-icon btn-icon-44" data-toggle="tooltip" data-trigger="hover" title="Add Another Section Info" onClick={e => this.addOfficialTestSection()}>
                                                                                                <i className="fa fa-plus-circle"></i> 
                                                                                            </a>
                                                                                            :
                                                                                            <a href="#" className="btn btn-default btn-icon btn-icon-44" data-toggle="tooltip" data-trigger="hover" title="Remove Section Info" onClick={e => this.removeOfficialTestSection(sectioni)}>
                                                                                                <i className="fa fa-minus-circle"></i> 
                                                                                            </a>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                
        
                                                                            </div>
                                                                            
                                                                            
                                                                            
                                                                        </div>
                                                                            
                                                                    )
                                                                })
                                                                }
                                                                
                                                                
                                                                
                                                        	</div>
                                                        </div>
                </div>
                
                {
                    courses &&
                    this.renderCourses(courses)
                }
            </div>
        </div>
    );



    renderTab = (className, link, title) => (
        <li
            className={className}
        >
            <a
                href={link}
                data-toggle="tab"
            >
                {title}s
            </a>
        </li>
    );

    renderCourses = (courses) => (
        courses.map((course, index) => (
            <div
                key={index}
                className="panel customPanel"
            >
                <div className="panel-heading border-bottom bg-dd">
                    <div className="panel-control">
                        <a
                            href="#AddStrategyModal"
                            data-toggle="modal"
                            className="btn btn-info"
                        >
                            <i className="zmdi zmdi-plus-circle"/>
                        </a>
                    </div>
                    <h3 className="panel-title text-uppercase font-400">
                    <span className="font-16">
                        <i className="zmdi zmdi-library padding-rgt"/>
                        {course.name}
                    </span>
                    </h3>
                </div>
                <div className="panel-body">
                    <SortableCoursesContainer
                        items={this.props.courses || []}
                        index={index}
                    />
                </div>
            </div>
        ))
    );

    renderSubjectSelect = () => {
        return this.state.activeCourse.CourseSubject.map(sub => {
            return (
                <option value={sub.id}>{sub.name}</option>
            )
        })
    }

    removeRule = (index) => {
        let {rules} = this.state;
        rules.conditions.splice(index, 1);
        this.setState({rules});
    }

    addCondition = (i, type) => {
        let {rules} = this.state;

        if(rules.conditions.length > 0) {

            if (rules.conditions[i].subjects.length > 0) {
                if (rules.conditions[i].subjects[rules.conditions[i].subjects.length - 1].connector === "") {
                    rules.conditions[i].subjects[rules.conditions[i].subjects.length - 1].connector = "and";
                }
            }
        }

        rules.conditions[i].subjects.push({
            id: "",
            type: "subject",
            condition: type,
            connector: ""
        });
        this.setState({rules});
    }

    removeCondition = (index, subIndex) => {
        let {rules} = this.state;
        rules.conditions[index].subjects.splice(subIndex, 1);
        this.setState({rules});
    }

    updateConditionSubject = (index, subIndex, value) => {
        let {rules} = this.state;
        rules.conditions[index].subjects[subIndex].id = value;
        this.setState({rules});
    }

    setConditionResult = (index, value) => {
        let {rules} = this.state;
        rules.conditions[index].result = value;
        this.setState({rules});

    }

    setConditionConnector = (index, connector) => {
        let {rules} = this.state;
        rules.conditions[index].subjects[rules.conditions[index].subjects.length - 1].connector = connector;
        this.setState({rules});

    }

    setConditionOperator = (index, subIndex, value) => {
        let {rules} = this.state;
        rules.conditions[index].subjects[subIndex].operator = value;
        this.setState({rules});

    }

    setConditionValue = (index, subIndex, value) => {
        let {rules} = this.state;
        rules.conditions[index].subjects[subIndex].value = value;
        this.setState({rules});
    }

    reorderConditions = ({oldIndex, newIndex}) => {
        let {rules} = this.state;
        rules.conditions = arrayMove(rules.conditions, oldIndex, newIndex);
        this.setState({rules});
    }
    
    reorderSubjects = ({oldIndex, newIndex}) => {
        let {subjectOrder} = this.state;
        subjectOrder = arrayMove(subjectOrder, oldIndex, newIndex);
        this.setState({subjectOrder});
    }
    
    renderManualStrategy = () => {
        let {subjectOrder} = this.state;
        if(subjectOrder){
            return (
                <div>
                    <SortableSubjects
                        subjects={subjectOrder}
                        onSortEnd={this.reorderSubjects}
                        fullSubjects={this.props.activeCourse.CourseSubject}
                        
                    />
                    <div className="manual-footer">
                        {subjectOrder.length !== this.props.activeCourse.CourseSubject.length &&
                            <span>
                                <button className="btn btn-default" onClick={this.updateLoadSubjects}><i className="zmdi zmdi-refresh" /> Load Unused Subjects</button> &nbsp; </span>
                        }
                        <button className="btn btn-primary" onClick={this.updateCourse}><i className="zmdi zmdi-save" /> Save Subject Order</button> &nbsp;
                        <button className="btn btn-default" onClick={this.updateAllCourseUserSubjects}><i className="zmdi zmdi-refresh" /> Sync All Students Subjects</button>
                    </div>
                </div>    
            )
        }
    }



    renderStrategyConditions = () => {
        let {rules} = this.state;

        if(rules) {
            return (
                <div className={`sm-bottom30 strategy_conditions ${this.state.strategy}`}>

                    <SortableRules
                        addCondition={this.addCondition}
                        removeRule={this.removeRule}
                        removeCondition={this.removeCondition}
                        setConditionOperator={this.setConditionOperator}
                        setConditionValue={this.setConditionValue}
                        setConditionConnector={this.setConditionConnector}
                        setConditionResult={this.setConditionResult}
                        updateConditionSubject={this.updateConditionSubject}
                        renderSubjectSelect={this.renderSubjectSelect}
                        onSortEnd={this.reorderConditions}
                        conditions={this.state.rules.conditions}


                    />
                    <div className="sm-top20">
                        <div className="flex flex-justify-content-space-between">
                            <button className="btn btn-danger"  onClick={(e) => {
                                rules.conditions.push({
                                    subjects: [],
                                    result: null
                                })
                                this.setState({rules});
                            }}><i className="zmdi zmdi-plus-circle"></i> Add Rule</button>
                            <div>
                                <button className="btn btn-success" onclick="TestRules()"><i className="zmdi zmdi-circle"></i> Test Rules</button>
                                <button className="btn btn-danger" onClick={e => {
                                    let {subjectScores} = this.state;
                                    subjectScores = [];
                                    this.state.activeCourse.CourseSubject.map(s => {
                                        subjectScores.push({subjectId: s.id, correctPercent: 0, name: s.name, order: 0});
                                    })
                                    this.setState({subjectScores});
                                }} data-target="#PreviewStrategyModal" data-toggle="modal"><i className="zmdi zmdi-eye"></i> Preview</button>

                            </div>
                        </div>
                    </div>
                    
                </div>

            )
        }

    }

    renderStrategyConditionsOld = () => (
        <div className={`sm-bottom30 strategy_conditions ${this.state.strategy}`}>
            <div className="panel customPanel">
                <div className="panel-body sp-20">
                    <p className="condition_list">
                        If Tie Between:
                        <select
                            className=""
                            value={this.state.activeCourse.tieAA || ''}
                            onChange={(e) => {
                                let {activeCourse} = this.state;
                                activeCourse.tieAA = e.target.value;
                                this.setState({activeCourse});
                            }}
                        >
                            <option value="">Choose</option>
                            {this.renderSubjectSelect()}
                        </select>
                        And
                        <select
                            className=""
                            value={this.state.activeCourse.tieAB || ''}
                            onChange={(e) => {
                                let {activeCourse} = this.state;
                                activeCourse.tieAB = e.target.value;
                                this.setState({activeCourse});
                            }}
                        >
                            <option value="">Choose</option>
                            {this.renderSubjectSelect()}
                        </select>
                        Then
                        <select
                            className=""
                            value={this.state.activeCourse.tieARank || ''}
                            onChange={(e) => {
                                let {activeCourse} = this.state;
                                activeCourse.tieARank = e.target.value;
                                this.setState({activeCourse});
                            }}
                        >
                            <option value="">Choose</option>
                            {this.renderSubjectSelect()}
                        </select>
                        takes higher rank.
                    </p>
                </div>
            </div>

            <div className="panel customPanel">
                <div className="panel-body sp-20">
                    <p className="condition_list">
                        If tie between
                        <select
                            className=""
                            value={this.state.activeCourse.tieBA || ''}
                            onChange={(e) => {
                                let {activeCourse} = this.state;
                                activeCourse.tieBA = e.target.value;
                                this.setState({activeCourse});
                            }}
                        >
                            <option value="">Choose</option>
                            {this.renderSubjectSelect()}
                        </select>
                        and
                        <select
                            className=""
                            value={this.state.activeCourse.tieBB || ''}
                            onChange={(e) => {
                                let {activeCourse} = this.state;
                                activeCourse.tieBB = e.target.value;
                                this.setState({activeCourse});
                            }}
                        >
                            <option value="">Choose</option>
                            {this.renderSubjectSelect()}
                        </select>
                        , and test is within
                        <input
                            className=""
                            value={this.state.activeCourse.tieBtestWithin || ''}
                            onChange={(e) => {
                                let {activeCourse} = this.state;
                                activeCourse.tieBtestWithin = e.target.value;
                                this.setState({activeCourse});
                            }}
                        />
                        days, then
                        <select
                            className=""
                            value={this.state.activeCourse.tieBPriority || ''}
                            onChange={(e) => {
                                let {activeCourse} = this.state;
                                activeCourse.tieBPriority = e.target.value;
                                this.setState({activeCourse});
                            }}
                        >
                            <option value="">Choose</option>
                            {this.renderSubjectSelect()}
                        </select>
                        takes periority.
                    </p>
                </div>
            </div>
            <div className="panel customPanel">
                <div className="panel-body sp-20">
                    <p className="condition_list">
                        If score for
                        <select
                            className=""
                            value={this.state.activeCourse.scoreFor || ''}
                            onChange={(e) => {
                                let {activeCourse} = this.state;
                                activeCourse.scoreFor = e.target.value;
                                this.setState({activeCourse});
                            }}
                        >
                            <option value="">Choose</option>
                            {this.renderSubjectSelect()}
                        </select>
                        is below
                        <input type="text"
                            value={this.state.activeCourse.score || ''}
                               onChange={(e) => {
                                   let {activeCourse} = this.state;
                                   activeCourse.score = e.target.value;
                                   this.setState({activeCourse});
                               }}
                        />
                        than it always take a higher rank.
                    </p>
                </div>
            </div>
            <p>
                If contradiction, then choose default.
            </p>
        </div>
    );

    renderSelect = () => (
        <select className="">
            <option value="">Choose</option>
            <option value="">A</option>
            <option value="">B</option>
        </select>
    );

    //Actions
    handleChangeCheckStrategy = (e) => {

        if (e.target.value === 'Manual') {
            let {activeCourse} = this.state;
            activeCourse.strategy = 'manual_strategy_active';
            this.setState({strategy: 'manual_strategy_active', activeCourse});
        } else {
            let {activeCourse} = this.state;
            activeCourse.strategy = '';
            this.setState({strategy: '', activeCourse});
        }
    };

    saveTest = (data) => {
        data.owner = this.props.user.userId;
        if(data.id){
            this.props.updateTest(data, this.props.user.id);
        }else {
            data.options = 'options';
            this.props.addTest(data, this.props.user.id);
        }
    }

    deleteTest = (id) => {
        this.props.deleteTest(id, this.props.user.id);
    }
    
    previewSubjectOrder = () => {
        var conditions = this.state.rules.conditions;
        let subjectOrder = [];
        this.state.subjectScores.sort((a, b) => a < b || b > a).map((ss, i) => {
            subjectOrder.push(ss.subjectId);  
        });
        let {subjectScores} = this.state;
        
          for(var i = 0; i < conditions.length; i++){
            //top level conditions.  each contains a series of matches/rules, and a result
            var matches = false;

            for(var s = 0; s < conditions[i].subjects.length; s++){
              // Each individual rule.  We need to test against test data here
              var rule = conditions[i].subjects[s];

                  if(rule.condition == "score"){
                    var relevantSections = this.state.subjectScores.filter(function(section){
                      return section.subjectId == rule.id;
                    });


                    if(relevantSections.length > 0){
                      if(rule.operator == "<"){
                        if(parseInt(relevantSections[0].correctPercent) < rule.value){
                          matches = true;
                        }
                      }else if(rule.operator == ">"){
                        if(parseInt(relevantSections[0].correctPercent) > rule.value){
                          matches = true;
                        }
                      }else if(rule.operator == "="){
                        if(parseInt(relevantSections[0].correctPercent) == rule.value){
                          matches = true;
                        }
                      }


                    }
                  }


                  if(rule.condition == "tie"){
                    var tieSubjects = [];
                    tieSubjects.push(rule.id);
                    var nextIndex = s + 1;

                    for(var n = s + 1; n > -1; n++) {
                      var nRule = conditions[i].subjects[n];
                      if(nRule) {

                        if (nRule.condition == "tie" && nRule.connector != "or") {
                          tieSubjects.push(nRule.id);
                        } else {
                          nextIndex = n;
                          n = -2;

                        }
                      }else{
                        nextIndex = conditions[i].subjects.length;
                        n = -2;
                      }
                    }


                    s = nextIndex;

                    var relevantSections = this.state.subjectScores.filter(function(section){
                      return tieSubjects.indexOf(section.subjectId) > -1;
                    });

                    var localMatches = 1;
                    for(var sec = 0; sec < relevantSections.length; sec++){
                      if(relevantSections[sec + 1]){
                        if(parseInt(relevantSections[sec].correctPercent) == parseInt(relevantSections[sec + 1].correctPercent)){
                          localMatches += 1;
                        }
                      }
                    }

                    if(localMatches == tieSubjects.length){
                      matches = true;
                    }



                  }
              }
              
              
              if(matches == true){
                if(subjectOrder[0] != conditions[i].result){
                  var indexOfSubject = subjectOrder.indexOf(conditions[i].result);
                  subjectOrder.splice(indexOfSubject, 1);

                  subjectOrder.unshift(conditions[i].result);
                  
                  
                }
                // continue building subjects
              }


          }
          
          let newSubjectScores = [];
          subjectOrder.map((so, i) => {
                let rs = subjectScores.filter(s => s.subjectId === so)[0];
                if(rs){
                    newSubjectScores.push({...rs, order: i + 1});
                }
          })
          this.setState({subjectScores: newSubjectScores});
    }
    
    prepareSubjectOrder = () => {
        
    }


    componentDidUpdate = (props, state) => {
        if(props.match.params.courseId !== this.props.match.params.courseId){
            props.getSingleCourse(this.props.match.params.courseId, this.props.user.id);
        }else if(this.props.courses && !this.props.match.params.courseId && props.courses[0]){
            props.history.push(`/strategy/${props.courses[0].id}`);
        }else if(this.props.courses && this.state.activeCourse != this.props.activeCourse){
            let course = this.props.activeCourse;
            let so = [];
            if(this.props.activeCourse.subjectOrder){
                so = this.props.activeCourse.subjectOrder;
            }else{
                if (this.props.activeCourse.CourseSubject) {
                    this.props.activeCourse.CourseSubject.map(s => {
                        so.push(s.id);
                    });
                }
            }
            this.setState({subjectOrder: so, strategy: course.strategy, activeCourse: course});

        }

    }
    
    //Lifecycle
    componentWillMount() {
        this.props.onLoadCourses(this.props.user.userId, this.props.user.id);
        this.props.loadTestsByUID(this.props.user.userId, this.props.user.id);
    };

    renderTabContent = (courses) => {
        if(this.state.activeCourse) {
            return (
                <div
                    className={'tab-pane active'}
                    id={this.state.activeCourse.id}
                >
                    {this.renderTabPaneBody(this.state.activeCourse.subjects)}
                </div>
            )
        }
    };

    render() {
        let {courses, tests} = this.props;
        tests = tests.filter(test => test != null);



        return (
            <div className="content-wrapper" id="content-container">
                {this.renderTitle()}
                <section className="content no-padding bg-dark">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="nav-tabs-custom no-bg">
                                {this.renderNavigationLinks()}
                                
                                <div className="tab-content no-bg no-padding">
                                    <div className="tab-pane active" id="tab_2">
                                        {this.props.activeCourse &&
                                            <div className="nav-tabs-custom no-bg inner-tabs">
                                                {this.renderNavigationTabs()}
                                                <div className="tab-content no-bg no-padding">
                                                {this.props.activeCourse.id &&
                                                    this.renderTabContent(this.props.tests)
                                                }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </section>
                {
                    this.state.newTabModelIsOpen &&
                    <AddCourseModal
                        onCloseModal={this.handleNewTabOpenState}
                        addNewCourse={this.addNewCourse}
                        user={this.props.user}
                    />
                }
                <StrategyModalCourseAdd />
                {this.props &&
                <StrategyModalDiagnosticTest
                    courses={this.props.courses}
                    course={this.props.activeCourse}
                    tests={this.props.tests || []}
                    saveTest={this.saveTest}
                    deleteTest={this.deleteTest}
                    setTest={this.setActiveCourseTest}
                    user={this.props.user}
                />
                }
                
                
        <div className="modal fade" id="PreviewStrategyModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                    <h4 className="modal-title" id="myModalLabel">Course Order Preview</h4>
                </div>
                <div className="modal-body">
                    {this.state.activeCourse &&
                    
                        this.state.subjectScores.map((s, si) => {
                            return (
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label>Subject {si + 1}</label>
                                            <select className="form-control">
                                                <option>{s.name}</option>
            
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Marks (percentage)</label>
                                            <input type="text" className="form-control" value={this.state.subjectScores[si].correctPercent} onChange={e => {
                                               let {subjectScores} = this.state;
                                              
                                                subjectScores[si].correctPercent = e.target.value;
                                               
                                               this.setState({subjectScores});
                                            }} />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <label>&nbsp;</label>
                                        <p className="order_number">{s.order}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                                        
                                        
                                        
                                        
                                    </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="button" onClick={this.previewSubjectOrder} className="btn btn-primary">Preview</button>
                </div>
            </div>
        </div>
    </div>
            </div>
        )
    }
}

export default StrategyManagement;



// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/StrategyManagement.js